import { Node, Edge } from '@xyflow/react';
import { NodeData } from './WorkflowBuilder.types';

/** Nodes reachable forward from the terminal decision node (BFS), including the root. */
export function getTerminalSubgraph(
    nodes: Node<NodeData>[],
    edges: Edge<NodeData>[],
    terminalId: string | null
): { nodes: Node<NodeData>[]; edges: Edge<NodeData>[] } {
    if (!terminalId) return { nodes: [], edges: [] };
    const reachable = new Set<string>();
    const queue: string[] = [terminalId];
    reachable.add(terminalId);
    while (queue.length > 0) {
        const id = queue.shift();
        if (id === undefined) break;
        edges.forEach((e) => {
            if (e.source === id && !reachable.has(e.target)) {
                reachable.add(e.target);
                queue.push(e.target);
            }
        });
    }
    return {
        nodes: nodes.filter((n) => reachable.has(n.id)),
        edges: edges.filter((e) => reachable.has(e.source) && reachable.has(e.target)),
    };
}
